import Skeleton from '@/components/Skeleton';
import { Link, Path } from '@phosphor-icons/react';
import { isEmpty, isEqual } from 'lodash';
import { useEffect, useState } from 'react';
import ViewDrillDowns from '@/features/reports/components/ViewDrillDowns';
import { Button } from '@/components/TSX components';
import useExploreStore from '../store/useExploreStore';
import { useShallow } from 'zustand/react/shallow';

export const DrillDownPaths = ({
  pathDetails,
  selected,
  loading,
  primarySource,
  tablePaths,
  setTablePaths,
  newMetricDetails,
  logoList,
  pathsLoading,
}) => {
  const [hoverInd, setHoverInd] = useState(-1);

  const {
    setDefaultDrillDownPathModalOpen,
    setDefaultDrillDownPathModalDetail,
  } = useExploreStore(
    useShallow((state) => {
      return {
        setDefaultDrillDownPathModalOpen:
          state.setDefaultDrillDownPathModalOpen,
        setDefaultDrillDownPathModalDetail:
          state.setDefaultDrillDownPathModalDetail,
      };
    })
  );

  // console.log(pathDetails.mergePaths[selected.tableName]);
  // console.log(pathDetails?.mergePaths);

  return (
    <div className="flex flex-col w-full h-full px-3 py-2.5 overflow-y-auto">
      {pathsLoading || loading ? (
        <div className="flex flex-col w-full h-full">
          <div className="flex w-full justify-between items-center">
            <Skeleton
              variant="rounded"
              width={'35%'}
              height="20px"
              className="bg-pv-neutral-grey-100 mb-2"
            />
            {/* <Skeleton
              variant="rounded"
              width={'100px'}
              height="20px"
              className="bg-pv-neutral-grey-100 mb-2"
            /> */}
          </div>
          {Array.from({ length: 5 }).map((_, ind) => {
            return (
              <div className="flex items-center gap-3 p-3" key={ind}>
                <Skeleton
                  variant="rounded"
                  width={'20px'}
                  height="20px"
                  className="bg-pv-neutral-grey-100"
                />
                {Array.from({ length: ind + 1 }).map((_, i) => {
                  return (
                    <div className="flex items-center gap-3" key={i}>
                      {i > 0 && (
                        <Skeleton
                          variant="rounded"
                          width={'16px'}
                          height="16px"
                          className="bg-pv-neutral-grey-100"
                        />
                      )}
                      <Skeleton
                        variant="rounded"
                        width={'110px'}
                        height="22px"
                        className="bg-pv-neutral-grey-100"
                      />
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      ) : !isEmpty(selected) &&
        Array.isArray(pathDetails?.mergePaths?.[selected?.tableName]?.paths) ? (
        pathDetails.mergePaths[selected.tableName].paths.length > 0 ? (
          <div className="flex flex-col w-full h-full gap-2">
            <div className="flex items-center justify-between w-full">
              <span className="font-medium text-xs pb-2 flex gap-2">
                <span className="text-pv-text-secondary-text">
                  {`Suggested Relationships: (${pathDetails.mergePaths[selected.tableName].paths.length})`}
                </span>
                <span className="flex gap-1 items-center">
                  <span>{primarySource}</span>
                  <Link />
                  <span>{selected.tableName}</span>
                </span>
              </span>
              {/* <ViewDrillDowns
                metricId={newMetricDetails.metricId}
                metrics={[
                  {
                    id: newMetricDetails.metricId,
                    name: newMetricDetails.metricName,
                    description: '',
                  },
                ]}
              >
                {({ setOpen }) => (
                  <Button
                    btnColor="blue ghost"
                    btnSize="sm"
                    onClick={() => setOpen(true)}
                  >
                    View drill-downs
                  </Button>
                )}
              </ViewDrillDowns> */}
            </div>
            <div className="flex flex-col w-full">
              {pathDetails.mergePaths[selected.tableName].paths.map(
                (path, i) => {
                  return (
                    <>
                      {i > 0 && (
                        <span className="h-[1px] w-full bg-pv-neutral-grey-100" />
                      )}
                      <div
                        className="relative flex w-full items-start justify-between border border-transparent hover:border-pv-primary-primary-500 rounded-lg hover:bg-pv-primary-primary-50"
                        key={i}
                        onMouseEnter={() => {
                          setHoverInd(i);
                        }}
                        onMouseLeave={() => {
                          setHoverInd(-1);
                        }}
                      >
                        <label
                          className={`gap-3 px-3 py-2.5 flex items-start cursor-pointer w-full`}
                          style={{
                            accentColor: '#3661ED',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <input
                            type="radio"
                            checked={isEqual(
                              tablePaths?.[selected.tableName]?.map((p) => ({
                                from: p.from,
                                how: p.how,
                                left_on: p.left_on,
                                right_on: p.right_on,
                                to: p.to,
                              })),
                              path?.map((p) => ({
                                from: p.from,
                                how: p.how,
                                left_on: p.left_on,
                                right_on: p.right_on,
                                to: p.to,
                              }))
                            )}
                            className="flex mt-2"
                            onChange={() => {
                              setTablePaths((prev) => ({
                                ...prev,
                                [selected.tableName]: path,
                              }));
                            }}
                          />
                          <p className="inline m-0 leading-7">
                            {Array.isArray(path) &&
                              path.length > 0 &&
                              path.map((conn, ind, arr) => {
                                return (
                                  <>
                                    {ind === 0 ? (
                                      <span
                                        key={ind}
                                        className="inline-flex gap-1 items-center"
                                        style={{
                                          verticalAlign: 'middle',
                                        }}
                                      >
                                        <img
                                          src={logoList[conn?.leftPlatform]}
                                          className="w-4"
                                          style={{
                                            aspectRatio: 1,
                                          }}
                                        />
                                        <span>{conn?.from}</span>
                                        <span className="bg-pv-primary-primary-100 px-2 py-0.5 rounded-lg text-xs">
                                          {conn?.left_on}
                                        </span>
                                        <Path size={16} />
                                        <img
                                          src={logoList[conn?.rightPlatform]}
                                          className="w-4"
                                          style={{
                                            aspectRatio: 1,
                                          }}
                                        />
                                        <span>{conn?.to}</span>
                                        <span className="bg-pv-primary-primary-100 px-2 py-0.5 rounded-lg text-xs">
                                          {conn?.right_on}
                                        </span>
                                      </span>
                                    ) : (
                                      <span
                                        key={ind}
                                        className="inline-flex gap-1 items-center ml-1"
                                        style={{
                                          verticalAlign: 'middle',
                                        }}
                                      >
                                        {conn?.left_on ===
                                        arr?.[ind - 1]?.right_on ? null : (
                                          <>
                                            <span className="w-[1px] h-[12px] bg-pv-text-primary-text" />
                                            <span className="bg-pv-primary-primary-100 px-2 py-0.5 rounded-lg text-xs">
                                              {conn?.left_on}
                                            </span>
                                          </>
                                        )}
                                        <Path size={16} />
                                        <img
                                          src={logoList[conn?.rightPlatform]}
                                          className="w-4"
                                          style={{
                                            aspectRatio: 1,
                                          }}
                                        />
                                        <span>{conn?.to}</span>
                                        <span className="bg-pv-primary-primary-100 px-2 py-0.5 rounded-lg text-xs">
                                          {conn?.right_on}
                                        </span>
                                      </span>
                                    )}
                                  </>
                                );
                              })}
                          </p>
                        </label>
                        {typeof pathDetails.mergePaths[selected.tableName]
                          ?.globalPath === 'boolean' &&
                          pathDetails.mergePaths[selected.tableName]
                            .globalPath &&
                          i === 0 && (
                            <span className="text-xs italic text-pv-text-secondary-text pr-3 pt-4">
                              Default
                            </span>
                          )}
                        {hoverInd >
                          (typeof pathDetails.mergePaths[selected.tableName]
                            ?.globalPath === 'boolean' &&
                          pathDetails.mergePaths[selected.tableName].globalPath
                            ? 0
                            : -1) &&
                          hoverInd === i && (
                            <Button
                              btnColor="blue ghost"
                              btnSize="sm"
                              className="absolute right-[4px] top-[12px] bg-pv-primary-primary-50 opacity-90"
                              onClick={() => {
                                setDefaultDrillDownPathModalDetail({
                                  ...selected,
                                  path: path,
                                });
                                setDefaultDrillDownPathModalOpen(true);
                              }}
                            >
                              Mark&nbsp;as&nbsp;default
                            </Button>
                          )}
                      </div>
                    </>
                  );
                }
              )}
            </div>
          </div>
        ) : selected?.tableName === primarySource ? (
          <div className="flex w-full h-full items-center justify-center">
            <p className="w-[80%] text-center text-pv-text-secondary-text font-medium text-xs">
              No relationship required.
            </p>
          </div>
        ) : (
          <div className="flex w-full h-full items-center justify-center">
            <p className="w-[80%] text-center text-pv-text-secondary-text font-medium text-xs">
              No relationships found. You can add a drill-down or import
              relationships from other definitions to proceed.
            </p>
          </div>
        )
      ) : (
        <div className="flex w-full h-full items-center justify-center">
          <p className="w-[80%] text-center text-pv-text-secondary-text font-medium text-xs">
            Get suggested relationships for different drill-downs here with
            source table
          </p>
        </div>
      )}
    </div>
  );
};
